/**
 * Created by joe on 16/9/6.
 */
module.exports = require('./lib/DragScroll');